import { createContext, useContext, useMemo, useState } from "react";
import { initialCommercialFilters } from "./commercialFilters";
const Context = createContext(null);
export function CommercialFilterProvider({ children }) {
  const [filters, setFilters] = useState(initialCommercialFilters);
  const value = useMemo(() => ({ filters, setFilters }), [filters]);
  return <Context.Provider value={value}>{children}</Context.Provider>;
}
export function useCommercialFilters() {
  const shared = useContext(Context);
  const [local, setLocal] = useState(initialCommercialFilters);
  return shared || { filters: local, setFilters: setLocal };
}
